

import { ProjectsEffects } from './_features/projects/projects.effect';
import { EffectsModule } from '@ngrx/effects';
// app-store.module.ts
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { rootReducer } from './store.reducer';
import { SharedModule } from '../shared.module';
import { ProfileEffects } from './_features/profile/profile.effect';
import { ProjectContentEffects } from './_features/projects/content/content.effect';

let stateEffects = [
  ProjectsEffects,
  ProjectContentEffects,
  ProfileEffects
  
//Course Related
  

  
  
  
  
];
@NgModule({
  imports: [
    StoreModule.forRoot(rootReducer),
    EffectsModule.forRoot([...stateEffects]),
    SharedModule,
  ],
})
export class NGRXStoreModule {}
